import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import { Tooltip, useTheme } from "@mui/material";
import IconButton from "@mui/material/IconButton";

import { HEADER_HEIGHT, PROTRUDING_EDGE_WIDTH, SIDEBAR_TRANSITIONS } from "@/layouts/constants";
import useSidebarStore from "@/hooks/zustand/ui/useSidebarStore";

const BUTTON_WIDTH = 20;

interface ToggleSidebarButtonProps {
  sidebarWidth: number;
}

export function ToggleSidebarButton({ sidebarWidth }: ToggleSidebarButtonProps) {
  const theme = useTheme();
  const {
    sidebarOpen,
    actions: { closeSidebar, openSidebar },
  } = useSidebarStore();

  const toggleSidebar = sidebarOpen ? closeSidebar : openSidebar;

  return (
    <Tooltip title={sidebarOpen ? "Collapse" : "Expand"}>
      <IconButton
        aria-label="Toggle Sidebar"
        size="small"
        onClick={toggleSidebar}
        sx={{
          height: "20px",
          width: BUTTON_WIDTH,
          ":hover": { bgcolor: theme.palette.primary.main, color: theme.palette.common.white },
          border: "1px solid",
          borderColor: theme.palette.divider,
          bgcolor: theme.palette.background.paper,
          boxShadow: theme.shadows[4],
          position: "absolute",
          translate: sidebarOpen
            ? `${sidebarWidth - BUTTON_WIDTH / 2}px ${HEADER_HEIGHT / 2}px`
            : `${PROTRUDING_EDGE_WIDTH - BUTTON_WIDTH / 2}px ${HEADER_HEIGHT / 2}px`,
          transition: SIDEBAR_TRANSITIONS,
          zIndex: 3,
        }}
      >
        <ChevronLeftIcon
          sx={{
            scale: "70%",
            rotate: sidebarOpen ? "0deg" : "180deg",
            transition: theme.transitions.create("rotate", {
              duration: "1s",
            }),
          }}
        />
      </IconButton>
    </Tooltip>
  );
}
